import ActeTableLine from './ActeTableLine';

export default ActeTableLine;
